module.exports = "/_next/static/images/partners-8e315f4bf1a4559d63bdaa7ccdcc5ad7.svg";